export const CoreErrorMessages = {
  UNKNOWN_ERROR: 'Unknown Error',
} as const;
